/**
 * dbHelper.js
 *
 * Helper utility to store and retrieve files in IndexedDB.
 * Used to persist files across the OAuth login redirect cycle.
 */

const DB_NAME = "ResumebarDB";
const STORE_NAME = "files";
const FILE_KEY = "pending_resume";

export const storePendingFile = (file) => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
    request.onsuccess = (e) => {
      const db = e.target.result;
      try {
        const tx = db.transaction(STORE_NAME, "readwrite");
        const store = tx.objectStore(STORE_NAME);
        const putReq = store.put(file, FILE_KEY);
        putReq.onsuccess = () => resolve(true);
        putReq.onerror = () => reject(putReq.error);
      } catch (err) {
        reject(err);
      }
    };
    request.onerror = () => reject(request.error);
  });
};

export const getPendingFile = () => {
  return new Promise((resolve) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
    request.onsuccess = (e) => {
      const db = e.target.result;
      try {
        const tx = db.transaction(STORE_NAME, "readonly");
        const store = tx.objectStore(STORE_NAME);
        const getReq = store.get(FILE_KEY);
        getReq.onsuccess = () => resolve(getReq.result);
        getReq.onerror = () => resolve(null);
      } catch {
        resolve(null);
      }
    };
    request.onerror = () => resolve(null);
  });
};

export const clearPendingFile = () => {
  return new Promise((resolve) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onsuccess = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        resolve(true);
        return;
      }
      try {
        const tx = db.transaction(STORE_NAME, "readwrite");
        const store = tx.objectStore(STORE_NAME);
        const delReq = store.delete(FILE_KEY);
        delReq.onsuccess = () => resolve(true);
        delReq.onerror = () => resolve(false);
      } catch {
        resolve(false);
      }
    };
    request.onerror = () => resolve(false);
  });
};
